module.exports = {
      id: "arcade-usage",
      viewBox: "0 0 19.915 20.731",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#arcade",
      toString: function () {
        return this.url;
      }
    }